<template lang="pug">
div
  UiCardSection
    UiStack
      UiStackItem(fill)
        .ui-card-section-title {{ $t("companies.api_keys.title") }}
      UiStackItem
        UiButton(
          variant="primary"
          @click="addApiKey"
          icon="Plus"
        ) {{ $t("companies.api_keys.create_title") }}
  UiCardSection
    RestTable(
      namespace="api_keys"
      :headers="headers"
      ref="ApiKeysTable"
      :fetch-handler="getData"
      :disablePagination="true"
      embed
    )
      template(#cell:active="{ item }")
        UiBadge(
          size="sm"
          :variant="item.active == true ? 'success' : 'danger'"
        ) {{ item.active ? "Active" : "Disabled" }}
      template(#cell:name="{ item }")
        a(
          :href="`/ApiKeys/${item.id}/job_download`"
          target="_blank"
          v-if="item.status == 'ok'"
        ) {{ item.name }}
        span(v-else) {{ item.name }}
      template(#cell:actions="{ item }")
        UiStack(spacing="xs")
          UiButton(
            size="sm"
            variant="smooth-danger"
            @click="deleteApiKey(item)"
            v-if="item.status != 'started'"
            icon="Trash"
          ) {{ $t("actions.delete") }}
          UiButton(
            size="sm"
            variant="smooth-warning"
            v-if="(item.status == 'error') & ['twin_treasury_file', 'netvisor_opus_voucher', 'netvisor_importer_payment'].includes(item.ApiKey_type)"
            icon="PencilEdit"
          ) {{ $t("actions.edit") }}
  CreateApiKey(
    ref="CreateApiKey"
    @done="reloadList"
  )
</template>

<script>
import ApiCompanies from "@/api/companies.js";
import CreateApiKey from "@/modals/Companies/createApiKey.vue";
import ApiCompanyApiKeys from "@/api/companyApiKeys.js";

export default {
  components: {
    CreateApiKey,
  },

  data() {
    return {
      company: {},
      headers: [
        {
          key: "name",
          label: "Name",
          sortable: false,
        },
        {
          key: "api_key",
          label: "Api Key",
          sortable: false,
        },
        {
          key: "api_secret",
          label: "Api Secret",
          sortable: false,
        },
        {
          key: "created_by",
          label: "Created By",
          sortable: false,
        },
        {
          key: "active",
          label: "Active",
          sortable: false,
        },
        {
          key: "created_at",
          label: "Created at",
          sortable: false,
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
    };
  },
  methods: {
    reloadList() {
      this.$refs.ApiKeysTable.fetchData();
    },

    getData(params, config) {
      return ApiCompanyApiKeys.fetchApiKeys(
        this.$route.params.id,
        params,
        config,
      ).then((resp) => {
        return {
          items: resp.data.api_keys,
          meta: resp.data.meta,
        };
      });
    },

    addApiKey() {
      this.$refs.CreateApiKey.open(this.$route.params.id, null);
    },

    deleteApiKey(item) {
      this.$dialogConfirm({
        title: this.$t("actions.remove"),
        description: this.$t("actions.confirm_remove"),
        variant: "danger",
        icon: "briefcase-remove",
        okLabel: this.$t("actions.remove"),
        okVariant: "danger",
        okIcon: "Trash",
        cancelVariant: "smooth-secondary",
      }).then((result) => {
        if (!result) return;
        ApiCompanyApiKeys.deleteApiKey(this.$route.params.id, item.id).then(
          (resp) => {
            this.reloadList();
          },
        );
      });
    },
    fetchData() {
      ApiCompanies.getCompany(this.$route.params.id).then((resp) => {
        this.company = resp.data.company;
      });
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
